import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import Header from '../../components/common/Header'
import { PlainInput } from '../../components/common/Input'
import { UserWidget, Chip, Tab, ViewerWidget } from '../../components/search/'
import './explore.sass'

import { useSelector } from 'react-redux';

import { getCreatorsByTag, getAllCreatorsByTag, getCreatorsByUsername, getTrendingPosts } from '../../api/explore';
import { ImageCard } from '../../components/explore'
import { ExploreShimmer } from '../../components/common/Shimmer'

export default function Explore() {

    const [isMobile, setIsMobile] = useState(false);

    const exploreRef = useRef(0)
    const searchRef = useRef(0)
    const [creatorsByTag, setCreatorsByTag] = useState([]);
    const [creatorsByUsername, setCreatorsByUsername] = useState([]);
    const [trendingPosts, setTrendingPosts] = useState([]);
    const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight);
    const [currentActiveTab, setCurrentActiveTab] = useState(0);
    const [userQuery, setUserQuery] = useState('');
    const [filterToggleText, setFilterToggleText] = useState('Show Filters');
    const currentUser = useSelector(state => state.userState)
    const [loadingUsernameList, setLoadingUsernameList] = useState(true);
    let isDark = useSelector(state => state.isDark);

    const [selectedTags, setSelectedTags] = useState([])



    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));

    }

    const updateView = (v) => {
        if (v <= 580) {
            setIsMobile(true);
            document.getElementById('mainWrapper').classList.remove('padding')
            document.getElementById('mainWrapper').classList.add('zero-p')
            document.getElementById('mobileNav').style.display = "none"
            document.getElementById('desktopNav').style.display = "flex"
            document.getElementById('mainWrapper').style.cssText = "padding: 70px 0 0 0 !important"
            try {
                if (currentActiveTab === 0) {
                    exploreRef.current.style.display = "none";
                    searchRef.current.style.display = "block"
                    searchRef.current.style.maxWidth = "100%"
                    searchRef.current.style.flex = "100%"
                    searchRef.current.style.paddingRight = "0px"
                } else if (currentActiveTab === 1) {
                    searchRef.current.style.display = "none";
                    exploreRef.current.style.display = "flex"
                    exploreRef.current.style.maxWidth = "100%"
                    exploreRef.current.style.flex = "100%"
                    exploreRef.current.style.paddingRight = "0px"
                }
            } catch (e) { }
        }
        else {
            document.getElementById('mainWrapper').classList.add('padding')
            document.getElementById('mainWrapper').classList.remove('zero-p')
            document.getElementById('mobileNav').style.display = "none"
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
            setIsMobile(false)
            try {
                exploreRef.current.style.display = "flex"
                exploreRef.current.style.maxWidth = "50%"
                exploreRef.current.style.flex = "50%"
                searchRef.current.style.display = "block"
                searchRef.current.style.maxWidth = "50%"
                searchRef.current.style.flex = "50%"
                searchRef.current.style.paddingRight = "10px"
                document.getElementById('mainWrapper').classList.add('padding')
                document.getElementById('mainWrapper').classList.remove('zero-p')
            } catch (e) {

            }
        }
    }

    useEffect(() => {
        updateView(window.innerWidth)
    }, [])

    useEffect(() => {
        window.addEventListener('resize', v => {
            setBodyHeight(document.body.clientHeight);
            setBodyWidth(document.body.clientWidth);
        })
        updateView(bodyWidth)

        return () => window.addEventListener('resize', v => {
            setBodyHeight(document.body.clientHeight);
            setBodyWidth(document.body.clientWidth);
        })
    }, [bodyWidth, bodyHeight])



    const updateTab = (e, setIsActive) => {
        if (e == 0) {
            try {
                searchRef.current.style.display = "block";
                exploreRef.current.style.display = "none";
                searchRef.current.style.maxWidth = "100%"
                searchRef.current.style.flex = "100%"
                searchRef.current.style.paddingRight = "0px"
                setIsActive(0);
                setCurrentActiveTab(0);

            } catch (e) { }
        } else {
            try {
                searchRef.current.style.display = "none";
                exploreRef.current.style.display = "flex";
                exploreRef.current.style.maxWidth = "100%"
                exploreRef.current.style.flex = "100%"
                exploreRef.current.style.paddingLeft = "0px"
                setIsActive(1);
                setCurrentActiveTab(1)
            } catch (e) { }
        }

    }

    useEffect(() => {
        document.getElementById('desktopNav').style.display = "flex"
        return () => {
            document.getElementById('mainWrapper').classList.add('padding')
            document.getElementById('mainWrapper').classList.remove('zero-p')
            document.getElementById('mobileNav').style.display = "flex"
        }
    }, [])




    async function updateCreatorsByUsernameList(query) {
        if (query.length == 0) {
            setCreatorsByUsername([]);
            return;
        }
        const res = await getCreatorsByUsername(query, currentUser.isCreator);
        const filtered = res.docs.filter(user => user.data().id != currentUser.id
            && (user.data().username.trim().toLowerCase().includes(query.trim()) || user.data().name.trim().toLowerCase().includes(query.trim())))
        setCreatorsByUsername(filtered);
    }


    const handleClearTags = () => {
        setSelectedTags([])
    }

    async function updateCreatorByTagsList() {
        const res = await getAllCreatorsByTag(selectedTags, selectedTags);
        const filtered = res.filter(user => user.id != currentUser.id)
        setCreatorsByTag(filtered);
        setLoadingUsernameList(false);
    }
    useEffect(() => {
        setLoadingUsernameList(true);
        updateCreatorByTagsList();
    }, [selectedTags, selectedTags, currentUser.id])

    let trendTemp = []
    const loadTrendingPosts = async () => {
        trendTemp = []
        getTrendingPosts(observer => {
            for (var i = 0; i < observer.docs.length; i++) {
                trendTemp.push(observer.docs[i].data())
            }
            const sortedTemp = trendTemp.sort((y, x) => (x.likesCount / (new Date() - x.time.toDate())) - (y.likesCount / (new Date() - y.time.toDate())))
            setTrendingPosts(sortedTemp)
        })
    }

    useEffect(() => {
        // loading trending posts
        loadTrendingPosts();
    }, [currentUser.id])

    useEffect(() => {
        if (userQuery.length == 0) {
            setCreatorsByUsername([]);
        }
    }, [userQuery])


    const handleSearchInput = async (e) => {
        setUserQuery(e.target.value)
        if (e.target.value.length == 0) {
            setCreatorsByUsername([])
            return;
        }
        updateCreatorsByUsernameList(e.target.value);
    }

    const hideFilters = async () => {
        if(document.getElementById('exploreTags').classList.contains('explore-tags-expanded')){
            document.getElementById('exploreTags').classList.add('explore-tags-hidden')
            await sleep(400);
            document.getElementById('exploreTags').classList.remove('explore-tags-expanded')
            setFilterToggleText('Show Filters')
        } else {
            document.getElementById('exploreTags').classList.remove('explore-tags-hidden')
            document.getElementById('exploreTags').classList.add('explore-tags-expanded')
            setFilterToggleText('Hide Filters')

        }
    }


    return (
        <div id="exploreWrapper">
            { isMobile ?
                <div id="exploreTabBar">
                    <Tab
                        title="Explore"
                        onUpdate={updateTab}
                        text="Search"
                        img="search"
                        text2="Explore"
                        img2="compass" />
                </div> : ''}
            <div id="exploreRow">
                <div ref={searchRef} id="exploreLCol" >
                    <div className="search-header">
                        <Header text="Search Lovers" img="search.svg" />
                    </div>
                    <div className="search-input">
                        <PlainInput handleOnChange={handleSearchInput} placeholder="Search Lovrs" />
                    </div>
                    {userQuery.length !=0 && creatorsByUsername.length != 0 &&  <h2>Search results</h2>}
                    {userQuery.length !=0 && creatorsByUsername.length != 0  && 
                         creatorsByUsername.map(user =>
                            user.data().isCreator ?
                                <UserWidget
                                    key={user.data().id}
                                    name={user.data().name}
                                    username={user.data().username}
                                    thumb={user.data().thumbnail}
                                    image={user.data().image}
                                    followers={user.data().followersCount}
                                /> :
                                <ViewerWidget
                                    key={user.data().id}
                                    name={user.data().name}
                                    username={user.data().username}
                                    thumb={user.data().thumbnail}
                                    image={user.data().image}
                                    followers={user.data().followersCount}
                                />
                        )
                        }
                    
                    {userQuery.length == 0 && <h2>Trending Posts</h2>}
                    {userQuery.length == 0 && <div className="trending-posts"> {trendingPosts.map(post => <ImageCard img={post.media} thumb={post.thumbnail} userId={post.user} postId={post.id} type={post.type} />)} </div>}

                </div>
                <div ref={exploreRef} id="exploreRCol">
                    <div className="search-header">
                        <Header text="Explore" img="compass.svg" />
                    </div>
                    <div id="exploreTags">
                        <Chip text="Kinky" isActive={selectedTags.includes('Kinky')} handleToggle={(e) => {
                            if (selectedTags.includes('Kinky')) {
                                selectedTags.splice(selectedTags.indexOf("Kinky"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Kinky']);
                            }
                        }} />
                        <Chip text="Fetish" isActive={selectedTags.includes('Fetish')} handleToggle={(e) => {
                            if (selectedTags.includes('Fetish')) {
                                selectedTags.splice(selectedTags.indexOf("Fetish"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Fetish']);
                            }
                        }} />
                        <Chip text="Asian" isActive={selectedTags.includes('Asian')} handleToggle={(e) => {
                            if (selectedTags.includes('Asian')) {
                                selectedTags.splice(selectedTags.indexOf("Asian"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Asian']);
                            }
                        }} />
                        <Chip text="BDSM" isActive={selectedTags.includes('BDSM')} handleToggle={(e) => {
                            if (selectedTags.includes('BDSM')) {
                                selectedTags.splice(selectedTags.indexOf("BDSM"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'BDSM']);
                            }
                        }} />
                        <Chip text="Cosplay" isActive={selectedTags.includes('Cosplay')} handleToggle={(e) => {
                            if (selectedTags.includes('Cosplay')) {
                                selectedTags.splice(selectedTags.indexOf("Cosplay"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Cosplay']);
                            }
                        }} />
                        <Chip text="Big ass" isActive={selectedTags.includes('Big ass')} handleToggle={(e) => {
                            if (selectedTags.includes('Big ass')) {
                                selectedTags.splice(selectedTags.indexOf("Big ass"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Big ass']);
                            }
                        }} />
                        <Chip text="Big tits" isActive={selectedTags.includes('Big tits')} handleToggle={(e) => {
                            if (selectedTags.includes('Big tits')) {
                                selectedTags.splice(selectedTags.indexOf("Big tits"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Big tits']);
                            }
                        }} />
                        <Chip text="Latina" isActive={selectedTags.includes('Latina')} handleToggle={(e) => {
                            if (selectedTags.includes('Latina')) {
                                selectedTags.splice(selectedTags.indexOf("Latina"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Latina']);
                            }
                        }} />
                        <Chip text="Teen" isActive={selectedTags.includes('Teen')} handleToggle={(e) => {
                            if (selectedTags.includes('Teen')) {
                                selectedTags.splice(selectedTags.indexOf("Teen"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Teen']);
                            }
                        }} />
                        <Chip text="Pornstar" isActive={selectedTags.includes('Pornstar')} handleToggle={(e) => {
                            if (selectedTags.includes('Pornstar')) {
                                selectedTags.splice(selectedTags.indexOf("Pornstar"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Pornstar']);
                            }
                        }} />
                        <Chip text="Gay/Lesbian" isActive={selectedTags.includes('Gay/Lesbian')} handleToggle={(e) => {
                            if (selectedTags.includes('Gay/Lesbian')) {
                                selectedTags.splice(selectedTags.indexOf("Gay/Lesbian"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Gay/Lesbian']);
                            }
                        }} />
                        <Chip text="Ebony" isActive={selectedTags.includes('Ebony')} handleToggle={(e) => {
                            if (selectedTags.includes('Ebony')) {
                                selectedTags.splice(selectedTags.indexOf("Ebony"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Ebony']);
                            }
                        }} />
                        <Chip text="Amateur" isActive={selectedTags.includes('Amateur')} handleToggle={(e) => {
                            if (selectedTags.includes('Amateur')) {
                                selectedTags.splice(selectedTags.indexOf("Amateur"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Amateur']);
                            }
                        }} />
                        <Chip text="Mature" isActive={selectedTags.includes('Mature')} handleToggle={(e) => {
                            if (selectedTags.includes('Mature')) {
                                selectedTags.splice(selectedTags.indexOf("Mature"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'Mature']);
                            }
                        }} />
                        <Chip text="MILF" isActive={selectedTags.includes('MILF')} handleToggle={(e) => {
                            if (selectedTags.includes('MILF')) {
                                selectedTags.splice(selectedTags.indexOf("MILF"), 1);
                                setSelectedTags([...selectedTags])
                            } else {
                                setSelectedTags([...selectedTags, 'MILF']);
                            }
                        }} />
                        <div onClick={handleClearTags} class="clear-filters">
                        <p>Clear filters</p>
                    </div>
                    </div>
                    
                    <div className="hide-filter" onClick={hideFilters} id="hideFilter" >
                        <p>{filterToggleText}</p>
                    </div>
                    

                    <div className="user-suggestions">
                        <h2>Suggestion</h2>
                        <div className="search-user-widget-container">
                            {
                                loadingUsernameList ?
                                <div >
                                    <ExploreShimmer />
                                    <ExploreShimmer />
                                    <ExploreShimmer />
                                    <ExploreShimmer />
                                    <ExploreShimmer />
                                    <ExploreShimmer />
                                    <ExploreShimmer />
                                    <ExploreShimmer />
                                </div> :
                                creatorsByTag.length > 0 ? 
                                creatorsByTag.map(user => <UserWidget key={user.id} name={user.name} username={user.username} thumb={user.thumbnail} image={user.image} followers={user.followersCount} price={user.price} />) : 
                                <div> </div>
                            }
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}
